import store from '@/store'
import utils from '@/common/util/utils'
import { URL_COOKIE_DOMAIN } from '@/common/constant'
import {
  PATH_NAME_COVER,
  PATH_NAME_HOME,
  PATH_NAME_PLAYER,
  PATH_NAME_ROUTER_TEST,
  PATH_NAME_SCHEDULE,
  PATH_NAME_SHORT_CUT_SMS,
  PATH_NAME_SIGNUP_REDIRECT,
  PATH_NAME_PLAYER_MOVIE_DETAIL_INFO,
  PATH_NAME_PLAYER_VOD_DETAIL_INFO,
  PATH_NAME_WAITING_SERVICE,
  PATH_NAME_WAVVEON_INTRO,
  PATH_NAME_USER_PUSH_MARKETING_ENABLE,
  PATH_NAME_CONNECTION,
  PATH_NAME_DIRECT_LOGIN,
  PATH_NAME_CONSENT_PROMOTION,
} from '@/common/router.const'
import { get, defaultTo } from 'lodash'
import { STORAGE_CONTENT_FROM_SEARCH } from '@/common/resources/const'

let otherRoutes = [
  {
    path: '/player/:section',
    name: PATH_NAME_PLAYER,
    components: {
      player: () =>
        import(
          /* webpackChunkName: "play" */ '@/views/play/ContentDetailView.vue'
        ),
    },
    props: true,
    beforeEnter(to, from, next) {
      store.commit('hideNavigationMenu')
      if (from.name !== 'login' && from.name !== 'profile_list') {
        utils.cookies.setItem(
          'referer-url',
          from.fullPath,
          null,
          URL_COOKIE_DOMAIN,
          '/',
        )
      }
      if (defaultTo(get(from, 'name', ''), '').indexOf('search') > -1) {
        sessionStorage.setItem(STORAGE_CONTENT_FROM_SEARCH, 'y')
      }
      next()
    },
  },
  {
    path: '/schedule',
    name: PATH_NAME_SCHEDULE,
    alias: '/schedule/index.html',
    components: {
      schedule_view: () => import('@/views/schedule/ScheduleView'),
    },
  },
  {
    path: '/wavveon.html',
    name: PATH_NAME_WAVVEON_INTRO,
    components: {
      pooqzone: () =>
        import(/* webpackChunkName: "pooqzone" */ '@/views/pooqzone/PooqZone'),
    },
    props: true,
  },
  {
    path: '/shortcut/sms',
    name: PATH_NAME_SHORT_CUT_SMS,
    alias: '/shortcut/sms.html',
    components: {
      shortcut: () => import('@/views/shortcut/Sms'),
    },
  },
  {
    path: '/waiting/service',
    name: PATH_NAME_WAITING_SERVICE,
    components: {
      waiting: () =>
        import(/* webpackChunkName: "waiting" */ '@/views/wating_service'),
    },
  },
  {
    path: '/cover',
    name: PATH_NAME_COVER,
    components: {
      cover: () =>
        import(/* webpackChunkName: "cover" */ '@/views/cover/index'),
    },
  },
  {
    path: '/signup',
    name: PATH_NAME_SIGNUP_REDIRECT,
    redirect: (to) => {
      if (utils.cookies.hasItem('signup-credential')) {
        const autoLogin = utils.login.autoLoginProc()
        autoLogin.then(() => {
          const referer = get(to, 'query.referer', '')
          if (referer !== null && referer !== '' && referer !== undefined) {
            let res = referer.replace('http://', '')
            res = res.replace('https://', '')
            res = res.replace('www.wavve.com', '')
            res = res.replace('m.wavve.com', '')
            res = res.replace('localhost', '')
            location.href = res
          } else {
            return { name: PATH_NAME_HOME }
          }
        })
      } else {
        return { name: PATH_NAME_HOME }
      }
    },
  },
  {
    path: '/player/vod/detail',
    name: PATH_NAME_PLAYER_VOD_DETAIL_INFO,
    components: {
      player_vod_detail_info: () =>
        import(
          /* webpackChunkName: "waiting" */ '@/components/play/VodDetailInfo'
        ),
    },
  },
  {
    path: '/player/movie/detail',
    name: PATH_NAME_PLAYER_MOVIE_DETAIL_INFO,
    components: {
      player_movie_detail_info: () =>
        import(
          /* webpackChunkName: "waiting" */ '@/components/play/MovieDetailInfo'
        ),
    },
  },
  {
    path: '/user/push/marketing/enable',
    name: PATH_NAME_USER_PUSH_MARKETING_ENABLE,
    components: {
      homeLayout: () => import('@/views/web-view/events/AppPushActivate.vue'),
    },
  },
  {
    path: '/connection/sns',
    name: PATH_NAME_CONNECTION,
    meta: { needLogin: false },
    components: {
      connection: () => import('@/views/connection'),
    },
  },
  {
    path: '/direct_login',
    name: PATH_NAME_DIRECT_LOGIN,
    components: {
      direct_login: () => import('@/views/login/DirectLoginView'),
    },
  },
  {
    path: '/consent/promotion',
    name: PATH_NAME_CONSENT_PROMOTION,
    components: {
      homeLayout: () => import('@/views/consent/ConsentPromotionView.vue'),
    },
  },
]

if (process.env.NODE_ENV !== 'production') {
  otherRoutes.push({
    path: '/router/test',
    name: PATH_NAME_ROUTER_TEST,
    components: {
      router_test: () => import('@/components/router/Test'),
    },
  })
}

export default otherRoutes
